// @flow
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Radio from 'common/domain/radio';
import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import { Metrics } from '../../themes';
import RadioConfigurationStepper from './components/RadioConfigurationStepper';
import RadioConfigurationAPI from './services/RadioConfigurationAPI';
import Introduction from './components/Introduction';
import { getCurrentRadio } from '../../modules/authentication/session/selectors/sessionSelectors';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${Metrics.largeMargin}px 0;
`;

const Title = styled.h1`
  margin-top: ${Metrics.largeMargin}px;
`;

const ContentWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-top: ${Metrics.largeMargin}px;

  @media screen and (max-width: 1375px) {
    width: 90%;
  }
`;

type Props = {
  radio: Radio,
  token: string,
  t: any,
}

type State = {
  hasReadIntroduction: boolean,
}

class RadioConfigurationPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasReadIntroduction: this.isNewRadio(props.radio),
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.radio !== nextProps.radio) {
      this.setState({ hasReadIntroduction: this.isNewRadio(nextProps.radio) });
    }
  }

  isNewRadio = (radio: Radio): boolean => {
    return !radio.configurationIs('INITIAL');
  }

  onIntroductionRead = async () => {
    const { radio, token } = this.props;
    const configuration = RadioConfigurationStep.of('INITIAL', { hasReadIntroduction: true });
    await RadioConfigurationAPI.saveStep(radio, token, configuration).then(() => this.setState({ hasReadIntroduction: true }));
  }


  render() {
    const { radio, token, t } = this.props;
    const { hasReadIntroduction } = this.state;

    return (
      <Wrapper>
        <Helmet>
          <title>{t('radioConfigurationPageTitle')}</title>
        </Helmet>
        <Title>{t('radioConfigurationPageTitle').toUpperCase()}</Title>
        <ContentWrapper>
          { !hasReadIntroduction ? <Introduction onButtonClick={this.onIntroductionRead} /> : <RadioConfigurationStepper radio={radio} token={token} /> }
        </ContentWrapper>
      </Wrapper>
    );
  }
}

function mapStateToProps(state: Object) {
  return {
    radio: getCurrentRadio(state),
    token: state.session.token,
  };
}

export default translate('radioConfiguration')(connect(mapStateToProps)(RadioConfigurationPage));




// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/RadioConfigurationPage.js